import { Flex, Text, TextVariant } from '@mprolab/uikit'
import { useTranslation } from 'react-i18next'
import * as React from 'react'
import styled from 'styled-components'

interface IAutostakeInfoProps {
  joinedAutostake: boolean
  button: React.ReactNode
}

const InfoWrapper = styled(Flex)<{ joinedAutostake: boolean }>`
  gap: 16px;
  padding: 16px;
  flex-direction: column;
  border-radius: 8px;
  align-items: center;
  background: #280f45;
  border: ${({ theme, joinedAutostake }) => (joinedAutostake ? 'none' : `1px solid ${theme.colors.purple}`)};
  align-items: ${({ joinedAutostake }) => (joinedAutostake ? 'center' : 'flex-start')};
`

const AutostakeInfo: React.FC<IAutostakeInfoProps> = ({ joinedAutostake, button }) => {
  const { t } = useTranslation()

  return (
    <InfoWrapper {...{ joinedAutostake }}>
      <Flex flexDirection="column" gap="8px">
        <Text variant={TextVariant.BODY_DEFAULT_BOLD} color="#FFFFFFE5">
          {t('rewards.joinStakeInfoTitle')}
        </Text>
        <Text variant={TextVariant.BODY_SMALL} color="#999999">
          {t('rewards.joinStakeInfoDescription')}
        </Text>
      </Flex>
      {button}
    </InfoWrapper>
  )
}

export default AutostakeInfo
